import { Card, SimpleGrid, Text } from '@chakra-ui/react'

import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import CustomFormEmptyAnswerFeedback from 'components/tools/CustomForm/commonComponents/CustomFormEmptyAnswerFeedback'

export default function CustomFormNPSAnswer() {
  const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']

  const { answer } = useCustomFormAnswer()

  return (
    <CustomFormEmptyAnswerFeedback>
      <SimpleGrid columns={5} gap={2}>
        {numbers.map((number) => {
          const answerValue = answer.answer ? answer.answer[0] : ''
          const isSelected = number === answerValue
          return (
            <Card
              key={number}
              tabIndex={0}
              p={2}
              cursor="not-allowed"
              borderWidth="1px"
              borderColor={isSelected ? 'primary' : 'borderColor'}
              bg={isSelected ? 'primary' : 'bgContent'}
              color={isSelected ? 'light' : 'dark'}
            >
              <Text textAlign="center">{number}</Text>
            </Card>
          )
        })}
      </SimpleGrid>
    </CustomFormEmptyAnswerFeedback>
  )
}
